import Time from "common/Time";

export function getActivityFromCustomer(time?: Date | string): string {
  const timeString = time instanceof Date ? time.toISOString() : time;

  if (
    !timeString ||
    !Date.parse(timeString) ||
    timeString === "0001-01-01T00:00:00"
  ) {
    return "Ej aktiverad";
  }
  return Time.formatShort(timeString);
}
